import { useParams } from "react-router-dom"

import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined'

import PageWrapper from '/components/page-wrapper'
import logo from '/assets/images/smartix-logo.png'
import HelpText from '/help/reset-password'
import PasswordResetForm from '/components/login/reset-password-form'

const ResetPasswordForm = () => {

  const { token } = useParams()

  return (
    <PageWrapper title="Reset Password" HelpText={HelpText}>
      <div className='overflow-y-scroll w-full h-full'>
        <div className="flex flex-row w-full justify-around items-start pt-20">

          <div className='flex flex-col gap-10 items-center'>
            <div className='flex flex-row gap-5 items-center'>
              <img src={logo} style={{ width: 400 }} />

              <div className='flex flex-col items-start'>
                <div className='smartix home'>SMARTIX</div>
                <div className='studio home'>Studio</div>
              </div>

            </div>

            <div className='tagline'>Keep Your Brand in Their Pocket</div>
          </div>

          <div className="flex items-start justify-center signin-override">
            <PasswordResetForm token={token} />
          </div>

        </div>
        <div className="m-20 mt-10 text-2xl opacity-70">Emails and texts disappear among the daily flood of messages. Smartix Wallet Passes stay right where your customers can see them — on their phones, ready when needed.
          Whether it’s a document, renewal, reminder, or reward, your message is always visible, always current, and never forgotten. <a href="https://www.smartix.uk" target='_blank'>Discover Smartix<OpenInNewOutlinedIcon className='ml-2'/></a></div>
      </div>
    </PageWrapper>
  )
}

export default ResetPasswordForm

